module.exports = __webpack_public_path__ + "assets/img/22s.b6c057dd.png";